import React from "react";
import Switch from "@material-ui/core/Switch";
import styled from "styled-components";
import { AdditionalQuestionsPromptType } from "../types";
import Form from "react-bootstrap/esm/Form";

// Toggle row that reveals the optional secondary questions. A hairline divider
// separates it from the main field grid above.
const FormGroupStyled = styled(Form.Group)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 18px 0 0;
  padding-top: 18px;
  border-top: 1px solid var(--jm-line);

  && .form-label {
    margin: 0;
    font-family: var(--jm-sans);
    font-size: 13px;
    letter-spacing: 0;
    text-transform: none;
    color: var(--jm-ink-soft);
  }
`;

const AdditionalQuestionsPrompt = (props: AdditionalQuestionsPromptType) => {
  const { secondaryPrompt, showSecondaryQuestions, setShowSecondaryQuestions } =
    props;

  return (
    <FormGroupStyled controlId="secondaryPrompt">
      <Form.Label>{secondaryPrompt}</Form.Label>
      <Switch
        checked={showSecondaryQuestions}
        onChange={() => setShowSecondaryQuestions(!showSecondaryQuestions)}
        color="primary"
      />
    </FormGroupStyled>
  );
};

export default AdditionalQuestionsPrompt;
